import {TEMPORALITIES} from "frontend/constants/constants"

export const filterFields = {
  approval_state: 'approval_state',
}

export const STANDARDS_SOURCE = 'standards'
export const VS_SOURCE = 'visualstandard'
export const VS_BUNDLE_ID = 'VisualStandard'

export const STANDARD_APPROVAL_STATE = Object.freeze({
  rejected: -1, draft: 0, pending: 1, approved: 2, active: 3,
})

export const ADDITIONAL_INFO_CATEGORY = Object.freeze({
  anomaly: 0, prohibition: 1, additional_info: 2,
})

export const VIDEO_PLAYER_BEHAVIOUR = Object.freeze({
  hide_annotations: 0, show_annotations: 1, stop_on_annotations: 2,
})

export const VS_AT_A_GLANCE_CHART_X_AXIS_LIMIT = 31

export const STANDARD_ABILITY_CERTIFICATIONS_RENOVATION_PERIOD_UNITS = Object.freeze({
  days: {
    value: 0,
    token: TEMPORALITIES.day.token_temporality,
  },
  months: {
    value: 1,
    token: TEMPORALITIES.month.token_temporality,
  },
  years: {
    value: 2,
    token: TEMPORALITIES.year.token_temporality,
  },
})

export const ACTIONS_OVER_STANDARD = Object.freeze({
  EDIT_NAME: 1, REMOVE_STANDARD: 2, COPY_STANDARD: 3, MOVE_STANDARD: 4,
})

export const FORMAT_EXPANDED = 'expanded'
export const FORMAT_MIN = 'min'
export const FORMAT_NOTIFICATIONS = 'notifications'
export const FORMAT_PDF = 'pdf'
export const FORMAT_TABLE = 'table'

export const STANDARD_DATA_FORMATS = Object.freeze([
  FORMAT_EXPANDED,
  FORMAT_MIN,
  FORMAT_NOTIFICATIONS,
  FORMAT_PDF,
  FORMAT_TABLE,
])
